import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { connect, useSelector } from "react-redux";
import { compose, withApollo } from "react-apollo";
import { CloudSearchConfig } from "../../components/shared/CloudSearchConfig";
import { OpenSearchConfig } from "../../components/shared/OpenSearchConfig";
import { GET_SEARCH_ENGINE_MAPPER, LIST_IR_FILTER_LOOKUPS_MASTER } from "../../gql/landingapi/queries";
import { getAllData } from "../../utils/helpers/fetching";
import { OwcButton, OwcCard, OwcDivider, OwcIcon, OwcIconButton, OwcTypography } from "@one/react";
import {
  DEFAULT_MYLAB_FILTER,
  EMPTY_FILTER_LIST,
  entryType,
  equipmentStatus,
  equipmentStatusFilterList,
  listOfFiltersRequired,
  POSITION_IN_CLUSTER,
  SERIAL_NUMBER
} from "../../constants";
import EQUIP_DATA_MODEL_TABLE from "../../utils/constants/equipmentDataModelTable";
import DLabGrid from "../../components/DLabGrid/DLabGrid";
import EquipmentTitleBar from "./EquipmentTitle";
import EquipmentFilterBar from "./EquipmentFilterBar";
import { EquipmentsContext } from "./equipments-context/context";
import ConfirmDialog from "../../components/shared/ConfirmDialog";
import useDialog from "../../utils/hooks/useDialog";
import {
  CREATE_DIGITAL_LAB_LANDING_PAGE_USER_FILTER,
  DELETE_DIGITAL_LAB_LANDING_PAGE_USER_FILTER,
  UPDATE_DIGITAL_LAB_LANDING_PAGE_USER_FILTER
} from "../../gql/landingapi/mutations";
import MyEquipmentMenu from "./MyEquipmentMenu";
import Snackbar from "../snackbar/Snackbar";
import {
  convertToSnakeCase,
  getUniqValuesWithCaseInsensitive,
  onlyUnique,
  uniqList
} from "../../utils/helpers/text";
import MyLabSideBarTool from "./MyLabSideBarTool";
import { generateID, Notify, sortFilterFields, buildFiltersQuery, transformLuceneValues, getSearchEngineFieldType, SEARCH_ENGINE_TYPES, getFieldValue } from "@digitallab/grid-common-components";
import { Module } from "../../constants";
import DATA_MODEL_TABLE from "../../utils/constants/dataModelTable";
import EmptyMyLab from "../../icons/EmptyMyLab";
import { getMegaClusterIds, OPENSEARCH_CONFIGURATION, getSortField, replaceSpecialCharsWithSpace } from "../../components/shared/helpers";
import { isEqual, uniq } from "lodash";
import EquipmentStatusRenderer from "./EquipmentStatusRenderer";
import EquipmentTagsRenderer from "./EquipmentTagsRenderer";


export const replaceSpecialCharWithSpace = (value) => {
  // eslint-disable-next-line
  return value.replace(/[!@#$%^&*()+=\[\]{};:\\|,<>?~\-"\/]/g, " ");
};

const EquipmentPage = ({ userID, client, subEquipmentInfoAction }) => {
  const {
    myLabEquipment,
    myLabFiltersList,
    appliedFilter,
    setMyLabEquipment,
    fetchingMyLabEquipment,
    setMyLabFiltersList,
    setAppliedFilter,
    myLabCountInitial
  } = useContext(EquipmentsContext);
  const icons = useMemo(() => {
    return {
      "setting-icon": '<owc-icon name="settings" type="legacy" />'
    };
  }, []);

  const activeSiteName = useSelector((state) => state.user.site);
  let filterCount = useRef(0);
  const [isSaveActive, setIsSaveActive] = useState(false);
  const [myLabCount, setMyLabCount] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const { openDialog, ...dialogProps } = useDialog();
  const [defaultColDef, setDefaultColDef] = useState({
    flex: 1,
    minWidth: 160,
    floatingFilter: false
  });
  const searchInColumn = EQUIP_DATA_MODEL_TABLE;
  const gridRef = useRef();
  const allMegaclusterIds = useRef([]);
  //Ag-Grid function
  const [gridApi, setGridApi] = useState(null);
  const [totalRows, setTotalRows] = useState("0");
  const [rowPerPage, setRowPerPage] = useState(10);
  const [showMenu, setShowMenu] = useState(false);
  const [currentParams, setCurrentParams] = useState(null);
  const [selectedEquipment, setSelectedEquipment] = useState([]);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [sortObj, setSortObj] = useState({ colId: null, sort: null });
  const [showMyLab, setShowMyLab] = useState(true);
  const [showMyLabViewMode, setShowMyLabViewMode] = useState(false);
  const [showTextValue, setShowTextValue] = useState(false);

  useEffect(() => {
    setIsSaveDisabled(() => isEqual(selectedEquipment.sort(), myLabEquipment.sort()));
  }, [selectedEquipment, myLabEquipment]);

  useEffect(() => {
    if (isEditMode && !showMyLab) {
      setShowTextValue(false)
    } else if (isEditMode && showMyLab && showMyLabViewMode) {
      setShowTextValue(true)
    } else {
      setShowTextValue(false)
    }
  }, [showMyLab, showTextValue, isEditMode, showMyLabViewMode]);


  let agGridOptions = {
    showText: showTextValue,
    componentsAdded: selectedEquipment?.length
  };

  const actionRender = (params) => {
    return (
      getFieldValue(params?.data, "entry_type") !== entryType.clusterSubequipment && (
        <OwcIconButton
          flat
          type="outlined"
          icon="more_vertical"
          onClick={() => {
            setCurrentParams(params);
            setShowMenu(true);
          }}
          id={getFieldValue(params?.data, "id")}
        ></OwcIconButton>
      )
    );
  };

  const [masterDataFilters, setMasterDataFilters] = useState(EMPTY_FILTER_LIST);

  useEffect(() => {
    const getAllDropDownList = async () => {
      const REPO_config = {
        aws_appsync_graphqlEndpoint: process.env.REACT_APP_AWS_GRAPHQL_REPO_ENDPOINT
      };

      const belongingToGroupResponse = await getAllData({
        client,
        query: LIST_IR_FILTER_LOOKUPS_MASTER,
        dataPath: ["data", "listIRFilterLookups"],
        variables: {
          limit: 1000,
          field: DATA_MODEL_TABLE?.belongingToGroup?.key
        },
        drillData: true,
        awsAppSyncConfig: REPO_config
      });

      const belongingToGroup = uniqList(belongingToGroupResponse.items, "filterValue");

      const equipmentModelResponse = await getAllData({
        client,
        query: LIST_IR_FILTER_LOOKUPS_MASTER,
        dataPath: ["data", "listIRFilterLookups"],
        variables: {
          limit: 1000,
          field: DATA_MODEL_TABLE?.equipmentModel?.key
        },
        drillData: true,
        awsAppSyncConfig: REPO_config
      });

      const equipmentModel = uniqList(equipmentModelResponse.items, "filterValue");

      const equipmentNickNameResponse = await getAllData({
        client,
        query: LIST_IR_FILTER_LOOKUPS_MASTER,
        dataPath: ["data", "listIRFilterLookups"],
        variables: {
          limit: 1000,
          field: DATA_MODEL_TABLE?.equipmentNickName?.key
        },
        drillData: true,
        awsAppSyncConfig: REPO_config
      });

      const equipmentNickName = uniqList(equipmentNickNameResponse.items, "filterValue");

      const locationResponse = await getAllData({
        client,
        query: LIST_IR_FILTER_LOOKUPS_MASTER,
        dataPath: ["data", "listIRFilterLookups"],
        variables: { limit: 1000, field: DATA_MODEL_TABLE?.location?.key },
        drillData: true,
        awsAppSyncConfig: REPO_config
      });

      const location = uniqList(locationResponse.items, "filterValue");
      const tempArray = {
        belongingToGroup: getUniqValuesWithCaseInsensitive(belongingToGroup?.map((item) => item.filterValue)),
        equipmentNickName: getUniqValuesWithCaseInsensitive(equipmentNickName?.map((item) => item.filterValue)),
        equipmentModel: getUniqValuesWithCaseInsensitive(equipmentModel?.map((item) => item.filterValue)),
        location: getUniqValuesWithCaseInsensitive(location?.map((item) => item.filterValue)),
        status: equipmentStatusFilterList
      };
      setMasterDataFilters(tempArray);

      // To get all megacluster ids
      const ids = await getMegaClusterIds();
      allMegaclusterIds.current = uniq(ids);
    };
    getAllDropDownList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log("myLabEquipment", myLabEquipment);
    setSelectedEquipment(() => {
      return [...myLabEquipment];
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myLabEquipment]);

  useEffect(() => {
    if (gridApi) {
      onGridReady(gridApi);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowPerPage, searchText, myLabEquipment, isEditMode, appliedFilter, sortObj, showMyLab]);
  useEffect(() => {
    if (appliedFilter) {
      let filterDefinition = appliedFilter.filterDefinition;
      if (typeof filterDefinition === "string") {
        filterDefinition = JSON.parse(filterDefinition);
      }
      let obj = {};
      for (const key in listOfFiltersRequired) {
        // convertToSnakeCase(filterDefinition[key].key)
        if (
          filterDefinition[listOfFiltersRequired[key]] !== undefined &&
          filterDefinition[listOfFiltersRequired[key]] !== "null" &&
          filterDefinition[listOfFiltersRequired[key]]
        ) {
          if (typeof filterDefinition[listOfFiltersRequired[key]] === "string") {
            obj[convertToSnakeCase(listOfFiltersRequired[key])] = {
              values: [filterDefinition[listOfFiltersRequired[key]]],
              filterType: "set"
            };
          } else {
            obj[convertToSnakeCase(listOfFiltersRequired[key])] = {
              values: filterDefinition[listOfFiltersRequired[key]],
              filterType: "set"
            };
          }
        }
      }
      if (gridApi) {
        gridRef?.current?.api.setFilterModel(obj);
      }
    }
    //saveLastFavFilter(appliedFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedFilter]);

  const fetchSearchEngineMapper = async () => {
    try {
      const result = await client.query({
        query: GET_SEARCH_ENGINE_MAPPER,
        fetchPolicy: "cache-first",
      });

      return result?.data?.getSearchEngineMapper?.items || [];
    } catch (error) {
      console.error("Failed to fetch search engine mapper:", error);
      return [];
    }
  }

  const getCloudSearchQuery = (searchText, searchInColumn) => {

    if (searchInColumn) {
      // Create field-specific search queries
      const fieldQueries = Object.entries(searchInColumn).map(([key]) => {
        const snakeCaseField = convertToSnakeCase(key);
        return `${snakeCaseField}:*${searchText}*`;
      });
      return `(${fieldQueries.join(' OR ')})`;
    } else {
      // General text search across all fields
      return `*${searchText}*`;
    }
  }
  const getOpensearchQuery = (searchText, searchInColumn) => {
    let searchQuery = '';
    const searchTokens = searchText.split(/\s+/).filter(Boolean);
    const fields = Object.keys(searchInColumn).map(key => convertToSnakeCase(key));
    if (searchTokens.length > 0) {
      if (searchTokens.length > 1) {
        searchQuery = searchTokens
          .map(token => {
            const fieldOrGroup = fields.map(f => `${f}:*${token}*`).join(' OR ');
            return `(${fieldOrGroup})`;
          })
          .join(' AND ');
      } else {
        searchQuery = `(${fields.map(f => `${f}:*${searchText}*`).join(' OR ')})`;
      }
    }
    return searchQuery;
  }
  const getSearchQuery = (searchText, searchInColumn) => {
    let query = '';
    const sanitizedSearchText = replaceSpecialCharWithSpace(searchText);
    if (OPENSEARCH_CONFIGURATION) {
      query = getOpensearchQuery(sanitizedSearchText, searchInColumn);
    } else {
      query = getCloudSearchQuery(sanitizedSearchText, searchInColumn);
    }
    return query;
  }

  const dataSourceLucene = {
    async getRows(params) {
      const searchEngineMapper = await fetchSearchEngineMapper();
      const { startRow, sortModel, filterModel, groupKeys } = params.request;
      const siteNameType = getSearchEngineFieldType(searchEngineMapper, "site_name", SEARCH_ENGINE_TYPES.TEXT);
      const entryTypeType = getSearchEngineFieldType(searchEngineMapper, "entry_type", SEARCH_ENGINE_TYPES.LITERAL);
      const statusType = getSearchEngineFieldType(searchEngineMapper, "status", SEARCH_ENGINE_TYPES.TEXT);
      let agGridFilterModel = filterModel;
      let colId, sort;

      if (Object.keys(sortModel).length > 0) {
        colId = sortModel[0].colId;
        sort = sortModel[0].sort;
      }

      let myLabEquipmentString = "";

      // Build base Lucene query
      let baseQuery = `site_name:${transformLuceneValues({
        value: activeSiteName.replace(/"/g, '\\"'),
        type: siteNameType
      })} AND NOT status:${transformLuceneValues({
        value: equipmentStatus.deleted.value,
        type: statusType
      })} AND (entry_type:${transformLuceneValues({
        value: entryType.cluster,
        type: entryTypeType
      })} OR entry_type:${transformLuceneValues({
        value: entryType.standaloneEquipment,
        type: entryTypeType
      })})`;

      // Handle myLab equipment filtering
      if (myLabEquipment.length > 0 && isEditMode && appliedFilter.filterName === DEFAULT_MYLAB_FILTER.filterName) {
        const myLabIds = myLabEquipment.map(id => `_id:"${id}"`).join(' OR ');
        myLabEquipmentString = `(${myLabIds})`;
        baseQuery += ` AND ${myLabEquipmentString}`;
      }

      if (myLabEquipment.length > 0 && !isEditMode) {
        const myLabIds = myLabEquipment.map(id => `_id:"${id}"`).join(' OR ');
        myLabEquipmentString = `(${myLabIds})`;
        baseQuery += ` AND ${myLabEquipmentString}`;
      }

      let userFilters = params?.api?.getFilterModel();
      let clusterExpand = groupKeys.length > 0 ? true : false;

      // Handle cluster expansion
      if (clusterExpand) {
        userFilters = {};
        baseQuery = `cluster_id:"${groupKeys[params.parentNode.level]}" AND site_name:${transformLuceneValues({
          value: activeSiteName.replace(/"/g, '\\"'),
          type: siteNameType
        })} AND NOT status:${transformLuceneValues({
          value: equipmentStatus.deleted.value,
          type: statusType
        })}`;
      } else {
        baseQuery += ` AND NOT entry_type:${transformLuceneValues({
          value: entryType.clusterSubequipment,
          type: entryTypeType
        })}`;
      }

      // Handle search text with Lucene syntax
      let searchQuery = "";
      if (searchText) {
        searchQuery = getSearchQuery(searchText.trim(), searchInColumn);
      }

      const {
        listFilterObject,
        literalFilterObject,
        intFilterObject,
        doubleFilterObject,
        textFilterObject,
        dateFilterObject,
        textArrayFilterObject
      } = sortFilterFields(agGridFilterModel, searchEngineMapper, masterDataFilters);

      const builtQuery = buildFiltersQuery({
        objects: {
          listFilterObject,
          literalFilterObject,
          intFilterObject,
          doubleFilterObject,
          textFilterObject,
          dateFilterObject,
          textArrayFilterObject
        }, metric: 'metric', masterDataFilters
      });

      let finalQuery = baseQuery;

      if (searchQuery && !OPENSEARCH_CONFIGURATION) {
        finalQuery += ` AND ${searchQuery}`;
      }

      if (builtQuery.length) {
        finalQuery += ` AND ${builtQuery.join(' AND ')}`;
      }

      if (!clusterExpand) {
        finalQuery += ` AND -cluster_id:*`;
      }

      let myLabState =
        myLabEquipment.length !== 0 &&
        !isEditMode &&
        (appliedFilter.filterName === null || appliedFilter.filterName === DEFAULT_MYLAB_FILTER.filterName) &&
        Object.keys(userFilters)?.length === 0 &&
        (searchText === null || searchText === "") &&
        groupKeys.length === 0;


      let filterOption = null;

      if (searchText) {
        filterOption = OPENSEARCH_CONFIGURATION
          ? Object.values(searchInColumn).map(field => convertToSnakeCase(field.key))
          : '';
      }
      let optionList = {
        grid_id: "equipmentList",
        options: {
          start: startRow,
          size: myLabState ? myLabEquipment.length : rowPerPage,
          sort: clusterExpand ? "asc" : sort || "asc",
          sortBy: clusterExpand ? getSortField(convertToSnakeCase(POSITION_IN_CLUSTER), searchEngineMapper) : getSortField(colId || convertToSnakeCase(SERIAL_NUMBER), searchEngineMapper),
          searchValue: finalQuery,
          queryOptions: filterOption,
          ...(OPENSEARCH_CONFIGURATION && {
            isSearching: !!searchText?.trim(),
            searchText: replaceSpecialCharsWithSpace(searchText?.trim())
          })
        }
      };

      if (!clusterExpand) {
        optionList = {
          ...optionList,
          options: {
            ...optionList?.options
          }
        };
      }

      let result = null;
      if (myLabEquipment.length === 0 && !isEditMode) {
        result = { count: 0, data: [] };
        setMyLabCount(() => result?.data);
      } else if (
        myLabEquipment.length === 0 &&
        isEditMode &&
        appliedFilter.filterName === DEFAULT_MYLAB_FILTER.filterName
      ) {
        result = { count: 0, data: [] };
      } else {
        result = await (OPENSEARCH_CONFIGURATION ? OpenSearchConfig(optionList.options) : CloudSearchConfig(optionList.options));
      }
      if (myLabState) {
        let selectedCount = result?.data;
        selectedCount = selectedCount.map((x) => getFieldValue(x, "id"));
        selectedCount = selectedCount.reduce(function (a, b) {
          return a.concat(b);
        }, []);
        setMyLabCount(() => selectedCount);
        // Clean up stale IDs from myLabEquipment that no longer exist in the search engine
        if (selectedCount.length < myLabEquipment.length) {
          setMyLabEquipment(selectedCount);
        }
      }
      if (groupKeys.length === 0) {
        setTotalRows(result?.count);
      }

      params.success({
        rowData: result?.data,
        rowCount: result?.count
      });

      let nodes = params?.api?.getRenderedNodes();
      if (nodes && nodes.length === 0 && groupKeys.length === 0) {
        gridRef?.current?.api.showNoRowsOverlay();
      } else {
        gridRef?.current?.api?.hideOverlay();
      }
    }
  };

  const onRowGroupOpened = useCallback((e) => {
    if (e.node.expanded) {
      gridRef.current.api.refreshServerSide({
        route: e.node.key,
        purge: false
      });
    }
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      headerName: "",
      field: "id",
      minWidth: 130,
      pinned: "left",
      lockPinned: true,
      suppressSizeToFit: true,
      cellClass: "lock-pinned",
      cellStyle: (params) => {
        return params?.node?.level > 0 &&
          (getFieldValue(params?.data, "entry_type") === entryType?.cluster ||
            getFieldValue(params?.data, "entry_type") === entryType?.clusterSubequipment)
          ? {
            border: "none",
            backgroundColor: "#F5F5F2",
            backgroundImage: "conic-gradient(at 20% 90%, #FFFFFF 180deg, #F5F5F2 180deg)"
          }
          : {};
      },

      cellRendererParams: {
        suppressCount: true,
        suppressSizeToFit: true,
        checkbox: (params) => {
          if (!isEditMode) {
            return false;
          } else if (!showMyLab) {
            return false;
          }
          const node = params.node;
          const isGroupRow = node.level === 0;
          if (isGroupRow) {
            params.node.selectable = getFieldValue(params?.data, "entry_type") !== entryType?.clusterSubequipment;
          }
          return isGroupRow;
        },

        innerRenderer: (params) => {
          return "";
        }
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditMode, showMyLab]);

  const onGridReady = (params) => {
    const correctDataSource = dataSourceLucene;
    setGridApi(params);
    params?.api?.setServerSideDatasource(correctDataSource);
  };

  const dLabColumnDef = () => {
    let columnFields = [];
    let columnData = EQUIP_DATA_MODEL_TABLE;

    for (const key in columnData) {
      let defaultObj = {
        field: convertToSnakeCase(columnData[key].key),
        headerName: columnData[key].value,
        sortable: true,
        suppressMenu: true,
        valueFormatter: (params) => (params.value === "null" || !params.value ? "-" : params.value)
      };

      if (key === "status") {
        defaultObj = {
          field: convertToSnakeCase(columnData[key].key),
          headerName: columnData[key].value,
          sortable: true,
          suppressMenu: true,
          cellRenderer: EquipmentStatusRenderer,
          valueFormatter: (params) => (params.value === "null" || !params.value ? "-" : params.value)
        };
      }

      if (key === "tags") {
        defaultObj = {
          field: convertToSnakeCase(columnData[key].key),
          headerName: columnData[key].value,
          sortable: false,
          suppressMenu: true,
          cellRenderer: EquipmentTagsRenderer,
          valueFormatter: (params) => (params.value === "null" || !params.value ? "-" : params.value)
        };
      }

      if (listOfFiltersRequired?.includes(columnData[key].key)) {
        defaultObj = {
          ...defaultObj,
          filter: "agSetColumnFilter",
          filterParams: {
            defaultToNothingSelected: true,
            buttons: ["reset"],
            values: (params) => {
              const values = masterDataFilters[columnData[key].key] || [];
              params.success(values);
            }
          }
        };
      } else {
        defaultObj = {
          ...defaultObj,
          filter: false
        };
      }

      columnFields.push(defaultObj);
    }
    if (!isEditMode) {
      columnFields = [
        ...columnFields,
        {
          field: "action",
          headerName: "Actions",
          maxWidth: 50,
          filter: false,
          pinned: "right",
          lockVisible: true,
          cellClass: "action-render",
          cellRenderer: actionRender
        }
      ];
    }

    if (isEditMode && !showMyLab) {
      columnFields = [
        ...columnFields,
        {
          field: "action",
          headerName: "Actions",
          maxWidth: 50,
          filter: false,
          pinned: "right",
          lockVisible: true,
          cellClass: "action-render",
          cellRenderer: actionRender
        }
      ];
    }

    return columnFields;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const isServerSideGroup = useCallback((dataItem) => {
    // TODO to disable expandable mode
    if (entryTypeCheck(dataItem.entry_type)) {
      return dataItem.id;
    }
    return "";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getServerSideGroupKey = useCallback((dataItem) => {
    // specify which group key to use
    if (entryTypeCheck(dataItem.entry_type)) {
      return dataItem?.id;
    }
    return "";
  }, []);
  const sideBarDef = useMemo(() => {
    let pannels = [
      {
        minWidth: 200,
        width: 276,
        id: "saveConfiguration",
        labelDefault: "Save configuration",
        labelKey: "saveConfiguration",
        iconKey: "setting-icon",
        toolPanel: (params) => {
          return (
            <MyLabSideBarTool
              id={generateID.UUID(Module.PAGE.MYLAB.title, `my_lab`, "sidebarTool")}
              params={params}
              createOrUpdateMyLabFilter={createOrUpdateMyLabFilter}
              deleteMyLabFilter={deleteMyLabFilter}
            />
          );
        }
      }
    ];

    const filtersDef = {
      minWidth: 200,
      width: 276,
      id: "filters",
      labelDefault: "Filters",
      labelKey: "filters",
      iconKey: "filter",
      toolPanel: "agFiltersToolPanel"
    };
    pannels = [filtersDef, ...pannels];
    return {
      toolPanels: pannels,
      defaultToolPanel: gridRef?.current?.api?.isSideBarVisible() ? "filters" : "",
      hiddenByDefault: !isFilterActive
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFilterActive]);
  const getFormattedFilter = (filters) => {
    if (Object.keys(filters).length > 0) {
      let tempFilter = {};
      for (const key in DEFAULT_MYLAB_FILTER.filterDefinition) {
        if (key !== "inventoryIds") {
          const convertedKey = convertToSnakeCase(key);
          if (filters[convertedKey]?.values !== undefined) {
            tempFilter[key] = filters[convertedKey].values;
          } else {
            tempFilter[key] = null;
          }
        } else if (key === "inventoryIds") {
          tempFilter[key] = [];
        }
      }
      return tempFilter;
    }
  };
  const onSortChanged = useCallback(() => {
    const value = gridApi.columnApi.getColumnState().find((s) => s.sort != null);
    if (value) {
      setSortObj({ colId: value?.colId, sort: value?.sort });
    }
  }, [gridApi]);

  let attr = {
    height: 480,
    rowModelType: "serverSide",
    rowQuickSearch: true,
    treeData: true,
    suppressPaginationPanel: true,
    paginationPageSize: rowPerPage,
    columnDefs: dLabColumnDef(),
    pagination: true,
    animateRows: true,
    rowSelection: "multiple",
    rowMultiSelectWithClick: true,
    rowExport: false,
    masterDetail: false,
    suppressContextMenu: true,
    isGroupOpenByDefault: false,
    defaultToolPanel: "filters",
    hiddenByDefault: true,
    cacheBlockSize: rowPerPage,
    serverSideInfiniteScroll: false,
    isServerSideGroup,
    getServerSideGroupKey,
    autoGroupColumnDef,
    onGridReady,
    setRowPerPage,
    rowPerPage,
    totalRows,
    entryType,
    sideBar: sideBarDef
  };

  const onFirstDataRendered = useCallback(() => {
    defaultColDef.floatingFilter = !defaultColDef.floatingFilter;
    defaultColDef.cellStyle = (params) => {
      const secondColumn = params.columnApi.getAllDisplayedColumns()[1].colDef.headerName;
      const headerName = params.colDef.headerName;
      const isSecondColumn = secondColumn === headerName ? true : false;
      if (isSecondColumn && params?.node?.level) {
        return {
          paddingLeft: `${10 + params?.node?.level * 20}px`
        };
      }
    };
    setDefaultColDef({ ...defaultColDef });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myLabEquipment, isEditMode]);

  const onRowSelected = useCallback(
    (params) => {
      if (isEditMode && (params?.source === "checkboxSelected" || params?.source === "rowClicked")) {
        const id = getFieldValue(params?.data, "id");
        setIsSaveActive(true);
        if (!selectedEquipment.includes(id)) {
          //selected scenario
          setSelectedEquipment((prevState) => {
            return onlyUnique([...prevState, id]);
          });
        } else {
          // un-selected
          let uniqueList = onlyUnique(selectedEquipment);
          const index = uniqueList.indexOf(id);
          if (index > -1) {
            let temp = uniqueList;
            temp.splice(index, 1);
            setSelectedEquipment(() => {
              return temp;
            });
          }
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isEditMode, selectedEquipment]
  );

  const updateMyLabEquipment = async () => {
    //const userSelectedRows = getSelectedRowData();
    //const equipmentIds = userSelectedRows.map((x) => x.id[0]);
    const myLabfilters = myLabFiltersList.find((x) => x.filterName === DEFAULT_MYLAB_FILTER.filterName);
    if (typeof myLabfilters?.filterDefinition === "string") {
      myLabfilters.filterDefinition = JSON.parse(myLabfilters?.filterDefinition);
    }
    //separate default equipment from initial Userfilter
    let filteredArray = [];
    if (myLabCountInitial !== undefined) {
      filteredArray = myLabCountInitial.filter((x) => !myLabCount.includes(x));
    }
    //user selected equipments
    let tempFilterDefinition = myLabfilters ? myLabfilters?.filterDefinition : DEFAULT_MYLAB_FILTER?.filterDefinition;
    tempFilterDefinition.inventoryIds = onlyUnique(selectedEquipment);
    //push default to user selected equipments
    let filtertested = tempFilterDefinition?.inventoryIds || [];
    filtertested = filtertested.concat(filteredArray);
    tempFilterDefinition.inventoryIds = onlyUnique(filtertested);
    //DEFAULT_FILTER
    try {
      const saveResult = await client.mutate({
        mutation:
          myLabfilters.isDefaultAdded === undefined
            ? UPDATE_DIGITAL_LAB_LANDING_PAGE_USER_FILTER
            : CREATE_DIGITAL_LAB_LANDING_PAGE_USER_FILTER,
        variables: {
          userID,
          filterName: myLabfilters?.filterName,
          filterDefinition: JSON.stringify(tempFilterDefinition)
        }
      });

      if (saveResult?.data?.updateUserFilter || saveResult?.data?.createUserFilter) {
        const userFilters = await fetchingMyLabEquipment();
        if (myLabfilters.isDefaultAdded !== undefined && myLabfilters.isDefaultAdded === true) {
          setMyLabFiltersList(userFilters);
        }

        if (!showTextValue && isEditMode && !showMyLab) {
          setIsSaveActive(false);
          setShowMyLab(false);
          setIsEditMode(true);
          setMyLabEquipment(tempFilterDefinition.inventoryIds);
          setSearchText(null);
        } else {
          setIsSaveActive(false);
          setShowMyLab(true);
          setMyLabEquipment(tempFilterDefinition.inventoryIds);
          setIsEditMode(false);
          setAppliedFilter(DEFAULT_MYLAB_FILTER);
          setSearchText(null);
        }
        Notify({
          type: "success",
          icon: "circle_confirm",
          title: "",
          text: `My lab configuration successfully saved`
        })
      } else {
        Notify({
          type: "warning",
          icon: "caution",
          title: "",
          text: `My lab configuration failed to save`
        });
      }
    } catch (error) {
      Notify({
        type: "warning",
        icon: "caution",
        title: "",
        text: `My lab configuration failed to save`
      });
    }
  };
  const removeMyLabEquipment = async (id) => {
    if (id) {
      const myLabfilters = myLabFiltersList.find((x) => x.filterName === DEFAULT_MYLAB_FILTER.filterName);
      let tempFilterDefinition = myLabfilters?.filterDefinition;
      const inventoryIds = tempFilterDefinition.inventoryIds.filter((x) => x !== id);

      let filteredArray = [];
      if (myLabCountInitial !== undefined) {
        filteredArray = myLabCountInitial.filter((x) => !id.includes(x));
        tempFilterDefinition.inventoryIds = onlyUnique(inventoryIds.concat(filteredArray));
      }

      //DEFAULT_FILTER
      try {
        const response = await client.mutate({
          mutation:
            myLabfilters.isNotDefault === undefined
              ? UPDATE_DIGITAL_LAB_LANDING_PAGE_USER_FILTER
              : CREATE_DIGITAL_LAB_LANDING_PAGE_USER_FILTER,
          variables: {
            userID,
            filterName: myLabfilters?.filterName,
            filterDefinition: JSON.stringify(tempFilterDefinition)
          }
        });

        if (response.data === null || response.errors) {
          throw new Error(JSON.stringify(response.errors));
        }
        Notify({
          type: "success",
          icon: "circle_confirm",
          title: "",
          text: `My lab configuration successfully saved`
        });
      } catch (error) {
        Notify({
          type: "warning",
          icon: "alarm",
          text: error.message,
          title: "Error when saving My lab configuration"
        });
      }

      await fetchingMyLabEquipment();
      if (inventoryIds.length > 0) {
        setMyLabEquipment([...inventoryIds]);
      } else {
        setMyLabEquipment([]);
      }
      if (myLabCount?.length !== 0) {
        let myLabId = [];
        myLabId = myLabCount.filter((x) => x !== id);
        setMyLabCount(() => myLabId);
      }
    }
  };
  const createOrUpdateMyLabFilter = async (filterName = null, filterObj = null, isUpdateOperation = false) => {
    if (filterName && Object.keys(filterObj).length > 0) {
      const filterDefinition = JSON.stringify(getFormattedFilter({ ...filterObj }));

      try {
        await client.mutate({
          mutation: isUpdateOperation
            ? UPDATE_DIGITAL_LAB_LANDING_PAGE_USER_FILTER
            : CREATE_DIGITAL_LAB_LANDING_PAGE_USER_FILTER,
          variables: {
            userID,
            filterName,
            filterDefinition
          }
        });
        const userFilters = await fetchingMyLabEquipment();
        const myLabfilters = userFilters.find((x) => x.filterName === filterName);
        setMyLabFiltersList(userFilters);
        setAppliedFilter(myLabfilters);
        Snackbar({
          type: "success",
          icon: "circle_confirm",
          appName: null,
          text: `My lab configuration successfully saved`
        });
      } catch (err) {
        Snackbar({
          type: "warning",
          icon: "no",
          appName: null,
          text: `Failed to save my lab configuration`
        });
      }
    } else {
      Snackbar({
        type: "success",
        icon: "circle_confirm",
        appName: null,
        text: `Detail is missing`
      });
    }
  };
  const deleteMyLabFilter = async (filterName = null) => {
    if (filterName && filterName !== DEFAULT_MYLAB_FILTER?.filterName) {
      try {
        await client.mutate({
          mutation: DELETE_DIGITAL_LAB_LANDING_PAGE_USER_FILTER,
          variables: {
            userID,
            filterName
          }
        });

        const userFilters = await fetchingMyLabEquipment();
        setMyLabFiltersList(userFilters);
        if (filterName === appliedFilter.filterName) {
          setAppliedFilter([DEFAULT_MYLAB_FILTER]);
        }

        Snackbar({
          type: "success",
          icon: "circle_confirm",
          appName: null,
          text: `My lab configuration successfully saved`
        });
      } catch (err) {
        Snackbar({
          type: "success",
          icon: "circle_confirm",
          appName: null,
          text: `Failed to save my lab configuration`
        });
      }
    } else {
      Snackbar({
        type: "success",
        icon: "circle_confirm",
        appName: null,
        text: `Filter name is missing`
      });
    }
  };

  const CustomNoRowsOverlayWithNormalMode = (props) => {
    return (
      <div
        className="myLabNoDataOverLay"
        id={generateID.UUID(Module.PAGE.MYLAB.title, `customOverlay`, "div")}
      >
        <OwcTypography variant="title6">
          No equipment yet
          <OwcTypography variant="body2">
            Add your first equipment to get started
          </OwcTypography>
        </OwcTypography>
        <OwcIcon className="emptyIconMyLab">
          {" "}
          <EmptyMyLab />{" "}
        </OwcIcon>
        <OwcButton
          onClick={() => {
            let defaultFilter = { ...DEFAULT_MYLAB_FILTER };
            defaultFilter.filterName = null;
            setIsEditMode(true);
            setAppliedFilter(defaultFilter);
            setShowMyLabViewMode(true);
            setMyLabEquipment(myLabCount);
            setSearchText(null);
          }}
          style={{ margin: "0px 10px 0px 10px" }}
        >
          Select equipment
        </OwcButton>
      </div>
    );
  };
  const CustomNoRowsOverlayWithEditMode = (props) => {
    return (
      <>
        <div className="myLabNoDataOverLaywithoutEditMode">
          <OwcTypography variant="title6">
            There are no items available based on your selected filters criteria
          </OwcTypography>
        </div>
        <OwcDivider />
      </>
    );
  };
  const noRowsOverlayComponent = useMemo(() => {
    return isEditMode
      ? CustomNoRowsOverlayWithEditMode
      : filterCount.current === 0 && (searchText === null || searchText === "")
        ? CustomNoRowsOverlayWithNormalMode
        : CustomNoRowsOverlayWithEditMode;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditMode, searchText, filterCount.current]);

  const onModelUpdated = () => {
    let nodes = gridApi?.api?.getRenderedNodes();
    if (gridApi && gridApi?.api && isEditMode) {
      if (nodes && nodes?.length > 0 && selectedEquipment?.length > 0) {
        gridApi?.api?.forEachNode((node) => {
          return node.setSelected(node?.data && selectedEquipment.includes(getFieldValue(node?.data, "id")));
        });
      } else if (nodes && nodes?.length > 0) {
        gridApi?.api?.forEachNode((node) => {
          return node?.setSelected(false);
        });
      }
    } else if (nodes && nodes?.length > 0) {
      gridApi?.api?.forEachNode((node) => {
        return node?.setSelected(false);
      });
    }
  };

  const onViewportChanged = () => {
    let nodes = gridApi?.api?.getRenderedNodes();
    if (gridApi && gridApi?.api && isEditMode) {
      if (nodes && nodes?.length > 0 && selectedEquipment?.length > 0) {
        gridApi?.api?.forEachNode((node) => {
          return node?.setSelected(node?.data && selectedEquipment?.includes(getFieldValue(node?.data, "id")));
        });
      } else if (nodes && nodes?.length > 0) {
        gridApi?.api?.forEachNode((node) => {
          return node?.setSelected(false);
        });
      }
    } else if (nodes && nodes?.length > 0) {
      gridApi?.api?.forEachNode((node) => {
        return node?.setSelected(false);
      });
    }
  };
  const entryTypeCheck = (dataItem) => {
    if (OPENSEARCH_CONFIGURATION) {
      return getFieldValue(dataItem, "entry_type") === entryType?.cluster;
    } else {
      return dataItem?.entry_type?.includes(entryType?.cluster)
    }
  }
  const checkClusterSubequipment = (dataItem) => {
    if (OPENSEARCH_CONFIGURATION) {
      return getFieldValue(dataItem, "entry_type") === entryType?.clusterSubequipment;
    } else {
      return dataItem?.entry_type?.includes(entryType?.clusterSubequipment)
    }
  }
  const getRowStyle = (params) => {
    if (params?.data?.status && getFieldValue(params?.data, "status") === "Delete") {
      return { opacity: 0.5 };
    }
    if (params?.node?.level > 0) {
      if (entryTypeCheck(params?.data)) {
        return { borderBottom: "1px solid #F5F5F2" };
      }
    }
    if (params?.node?.level === 0 && entryTypeCheck(params?.data)) {
      return { borderBottom: "1px solid #706B69" };
    }
    if (params?.node?.level > 0 && checkClusterSubequipment(params?.data)) {
      return { borderBottom: "1px solid #F5F5F2" };
    }
  };

  return (
    <div>
      <OwcCard
        id={generateID.UUID(Module.PAGE.MYLAB.title, `equipmentpage`, "card")}
        style={{ padding: "10px 0" }}
        flat
      >
        <div style={{ marginLeft: "16px" }} slot="header">
          <EquipmentTitleBar id={generateID.UUID(Module.PAGE.MYLAB.title, `equipmentpage`, "titlebar")} showTextValue={showTextValue} />
          <EquipmentFilterBar
            searchText={searchText}
            setSearchText={setSearchText}
            gridRef={gridRef}
            isEditMode={isEditMode}
            setShowMyLabViewMode={setShowMyLabViewMode}
            showMyLabViewMode={showMyLabViewMode}
            setIsEditMode={setIsEditMode}
            defaultColDef={defaultColDef}
            setShowMyLab={setShowMyLab}
            showMyLab={showMyLab}
            setDefaultColDef={setDefaultColDef}
            setIsFilterActive={setIsFilterActive}
            isFilterActive={isFilterActive}
            id={generateID.UUID(Module.PAGE.MYLAB.title, `equipmentpage`, "filterbar")}
          />
        </div>
        <div style={{ width: "100%" }} id={generateID.UUID(Module.PAGE.MYLAB.title, `equipmentpage`, "dlab_grid_div")}>
          <DLabGrid
            {...attr}
            gridRef={gridRef}
            defaultColDef={defaultColDef}
            getRowStyle={getRowStyle}
            onFirstDataRendered={onFirstDataRendered}
            noRowsOverlayComponent={noRowsOverlayComponent}
            onRowSelected={onRowSelected}
            icons={icons}
            hidePagination={!(isEditMode || myLabCount?.length > 0)}
            onModelUpdated={onModelUpdated}
            onViewportChanged={onViewportChanged}
            onRowGroupOpened={onRowGroupOpened}
            options={agGridOptions}
            onSortChanged={onSortChanged}
          />
        </div>

        <div
          slot="footer"
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center"
          }}
        >
          {showTextValue && (
            <OwcButton
              onClick={() => {
                openDialog(setShowMyLab);
                // setShowMyLab(true);
                // setShowMyLabViewMode(false);
              }}
              variant="secondary"
              style={{ margin: "0px 10px 0px 10px" }}
            >
              Cancel
            </OwcButton>
          )}

          {showTextValue && (
            <OwcButton
              onClick={() => {
                if (selectedEquipment?.length === 0) {
                  setMyLabCount(() => []);
                  setMyLabEquipment([]);
                }
                if (isSaveActive) {
                  updateMyLabEquipment();
                  setShowMyLab(true);
                  setShowMyLabViewMode(false);
                }
              }}
              disabled={isSaveDisabled}
              style={{ margin: "0px 10px 0px 10px" }}
            >
              Save My lab
            </OwcButton>
          )}
          {((!isEditMode && myLabCount?.length > 0) || (!isEditMode && filterCount.current > 0)) && (
            <OwcButton
              variant="secondary"
              style={{ margin: "0px 10px 0px 10px" }}
              onClick={() => {
                let defaultFilter = { ...DEFAULT_MYLAB_FILTER };
                defaultFilter.filterName = null;
                setIsEditMode(true);
                setShowMyLabViewMode(true);
                setAppliedFilter(defaultFilter);
                setMyLabEquipment(myLabCount);
                setSearchText(null);
              }}
            >
              Edit My lab
            </OwcButton>
          )}
        </div>
      </OwcCard>
      <ConfirmDialog
        {...dialogProps}
        onApprove={() => {
          setSelectedEquipment(myLabEquipment);
          setIsSaveActive(false);
          setAppliedFilter(DEFAULT_MYLAB_FILTER);
          setIsEditMode(false);
          setSearchText(() => "");
          setShowMyLab(true);
          setShowMyLabViewMode(false);
        }}
        approveText="Discard"
        approveColor="error"
        approveVariant="contained"
        cancelText="Cancel"
        cancelVariant="outlined"
        cancelColor="primary"
        title="Equipment list"
        content={`Do you really want to discard changes`}
      />
      {showMenu && (
        <MyEquipmentMenu
          setShowMenu={setShowMenu}
          showMyLab={showMyLab}
          isEditMode={isEditMode}
          allMegaclusterIds={allMegaclusterIds}
          params={currentParams}
          removeMyLabEquipment={removeMyLabEquipment}
          updateMyLabEquipment={updateMyLabEquipment}
        />
      )}
    </div>
  );
};

const mapStateToProps = (store) => ({
  userID: store?.user?.id,
  email: store?.user?.email,
  lastFilter: store?.user?.lastFilter
});
export default compose(connect(mapStateToProps), withApollo)(EquipmentPage);
